import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { displayFormattedDate } from "../../services/commonService";
import RelevanceScore from "./RelevanceScore";
import * as FeatherIcon from "react-feather";

export default function SideCardNudgeDetails({ nudgeData, handleClose, is_side_card, handleCheckboxChange, selectedItems = [] }) {

  return (
    <>
      {/* Show More Nudge Data  */}
      <div className=" mb-3" >
        <div className={`col-md-12 custom_card_block full-width-nudges ${nudgeData?.impact_score >= 8 ? 'custom_active' : '' } `} >
          <div className="align-right side_card_minimize_div" > <span className="cursorP side_card_minimize_span" onClick={handleClose}><FeatherIcon.Minimize2 className="fa" /></span> </div>
         <div className="nudges_subblock nudges_subblock_full d-flex">
         {nudgeData?.event && (
            <>
            <div className="checkbox_block">
                <Form.Check
                  aria-label="option 1"
                  onChange={() => handleCheckboxChange(nudgeData?.id)}
                  checked={selectedItems.includes(nudgeData?.id)}
                />
              </div>
              <h6 className="content_main_head mr-1 ml-2">{nudgeData?.event}</h6> 
            </>  
            )}
              {nudgeData?.impact_score >= 8 && (
              <div className="contet_head_img">
                <img
                  src="/img/icons/trending-up_backcolor.png"
                  alt="image"
                  className="image_block"
                />
              </div>
            )}
                      </div>

          <div className="content_para ml-3">
          
            
         
            <div className="content_nudges_para">

              <div className="potential_impact">
                <span className="nudges_full_span">Potential Impact:</span> <br />
                <div style={{marginLeft: '10px'}}>{nudgeData?.potential_impact}</div>
              </div>

              {nudgeData?.relevant_solutions &&
              <div className="potential_impact">
                <span className="nudges_full_span">RELEVANT SOLUTION(S):</span> <br />
                <ul>
                  {nudgeData?.relevant_solutions?.map((solution, index) => (
                    <li key={index}>{solution}</li>
                  ))}
                </ul>
              </div>
              }

              {nudgeData?.value_selling_prompters &&
              <div className="potential_impact">
                <span className="nudges_full_span">Value Selling Prompters:</span> <br />
                <ul>
                  {nudgeData?.value_selling_prompters?.map((value_selling_prompter, index) => (
                    <li key={index}>{value_selling_prompter}</li>
                  ))}
                </ul>
              </div>
              }

              {/* <div className="row mb-3 mt-1">
                {nudgeData?.impact_score && (
                <div className="col-md-6">
                    <b className="mr-1">Impact Score: </b>{" "}
                    {nudgeData.impact_score}/10
                </div>
                )}

                {nudgeData?.event_date && (
                <div className="col-md-6 align-right">
                    
                    {displayFormattedDate (nudgeData.event_date, 'YYYY-MM-DD', true)}
                </div>
                )}                    
              </div> */}

              <div className="date_company_impact_block">
                  <div className="impact_company_block">
                      <div className="impact_score">
                      {nudgeData?.impact_score && (
                        
                        <RelevanceScore
                            relevanceScore={nudgeData.impact_score}
                            section="impact_score"
                          />
                      )}
                      </div>
                  </div>
                  <span className="date_italic">{displayFormattedDate (nudgeData.event_date, 'YYYY-MM-DD', true)}</span>
              </div>
              
            </div>
          </div>
        

        </div>

      </div>
      {/* End : Show More Nudge Data  */}
    </>
  );
}
